module.exports = __webpack_public_path__ + "img/bridge-sel.ce5702c9.svg";